import { FunctionComponent } from 'react';
import cn from 'classnames';
import { LoadingIcon } from '../components';

type LoadingProps = {
  className?: string;
};

export const Loading: FunctionComponent<LoadingProps> = ({ className }) => {
  return (
    <div className={cn('flex h-full items-center justify-center', className)}>
      <h2 className="text-gray-500">
        <LoadingIcon className="size-8" />
      </h2>
    </div>
  );
};

export const LoadingFullScreen: FunctionComponent = () => {
  return (
    <div className="absolute left-0 top-0 z-20 flex min-h-screen w-screen items-center justify-center bg-white px-4 pb-48 pt-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md p-8 py-12">
        <div className="flex items-center">
          <div className="text-right">
            <h2 className="mt-6 text-4xl font-extrabold text-gray-900">
              <Loading />
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};
